import { ActiveSuppliers, Agency_Branches } from "./ActiveClasses";
import { Countries } from "./Countries";
export class RevenueReportProperties {
  revenueId: string = "";
  revenueName: string = "";
  expDate: string = "";

}
export class selectRevenueReport {
  agencyId: string;
  supplierId: string;
  officeId: string;
}

export class RevenueManagementProperties {
  revenueId: number = 0;
  name: string = "";
  type: string = "";
  description: string = "";
  appliesOn: string = "";
  agencyId_BranchId: string = "";
  baseRuleAgency: string = "";
  travelDateFrom: string = "";
  travelDateTo: string = "";
  bookingDateFrom: string = "";
  bookingDateTo: string = "";
  selectionType: number = 0;
  isBookingDate: boolean = false;
  isTravelDate: boolean = false;
  isOficeId: boolean = false;
  isLocation: boolean = false;
  isDirection: boolean = false;
  oneWayDirection: boolean = false;
  roundTripDirection: boolean = false;
  multiTripDirection: boolean = false;
  perSegment: boolean = false;
  isValidatingAirline: boolean = false;
  isMarketingAirline: boolean = false;
  isOperatingAirline: boolean = false;
  applyonPromotionalFare: boolean = false;
  creationUser: number = 0;
  creationDate: string = "";
  modifyUser: number = 0;
  modifyDate: string = "";
  status: boolean = true;
  suppliersData: RevenueManagementSupplierFlights[] = [];
  flightLocationCountryForInsurance: RevenueManagementFlightLocationProperties = new RevenueManagementFlightLocationProperties();
  flightLocationDataIncluded: RevenueManagementFlightLocationProperties[] = [];
  flightLocationDataExcluded: RevenueManagementFlightLocationProperties[] = [];
  airlineFlightData: RevenueManagement_AirlineFlight[] = [];
  flightCalaculationData: RevenueManagementCalculationFlight[] = [];
  selectedSuppliersList: string[] = [];
  selectedOficeIdsList: string[] = [];
  selectedFromLocationLst: string[] = [];
  selectedToLocationList: string[] = [];
  selectedValidatingAirlineList: string[] = [];
  selectedMarkitingAirList: string[] = [];
  selectedOperatingAirlineList: string[] = [];
  agencyBranchList: string[] = [];
  expiryDate: string = "";
  isMasterAgencyRule:  boolean = false;
  applyChildAgency: boolean = false;
  applyChildBranches: boolean = false;
  applyHO = false;
  isTourCode = false;
  tourCode: string = "";
  requestTypeID: number = 0;
  applyonCodeShare: boolean = false;
  applyonInterlineFlight: boolean = false;

  //05-oct-23
  isDiscountSupplierCommission = false;
  isRegularDiscount = false;
  //end
  groupRevenueName: string="";
  applyOnCodeShareOnly: boolean = false;
  applyOnInterlineFlightOnly: boolean = false;
}
export class RevenueReportPropertise {
  groupName: string = "";
  expiryDate: string = "";
  agencyCodeList: string[];
  CreationUser: string = "";
  agencyId: string = "";
  isDeleted: boolean = false;
  CreationDate: string = "";
  ModifyDate: string = "";
  groupId: number;
}
 export enum AirlineControlType {
  validatingAirline = 1,
  marketingAirline = 2,
  operatingAirline=3
}

export class RevenueManagementFlightLocationProperties {
  flightLocationId: number = 0;
  revenueId: number = 0;
  fromLocation: string = "";
  toLocation: string = "";
  creationUser: number = 0;
  creationDate: string = "";
  modifyUser: number = 0;
  modifyDate: string = "";
  isIncluded: boolean = false;
  viaLocation: string = "";
  fromCountryCode: string = "";
  toCountryCode: string = "";
  }
export class RevenueManagement_AirlineFlight {
  revenueFlightId: number = 0;
  revenueId: number = 0;
  airlineId: string = "";
  airlineTypeId: number = 0;
  creationUser: number = 0;
  creationDate: string = "";
  modifyUser: number = 0;
  modifyDate: string = "";

}
export class RevenueManagementSupplierFlights {
  revenueSupplierId: number = 0;
  revenueId: number = 0;
  supplierId: string = "";
  officeId: string = "";
  creationUser: number = 0;
  creationDate: string = "";
  modifyUser: number = 0;
  modifyDate: string = "";
}
export class RevenueManagementCalculationFlight {
  revenueCalculationId: number = 0;
  revenueId: number = 0;
  passengerType: string[] = [];;
  cabinClass: string = "";
  rbd: string = "";
  calculatedOn: string = "";
  expression: string = "";
  valueAmount: number = 0;
  valuePercent: number = 0;
  creationUser: number = 0;
  creationDate: string = "";
  modifyuser: number = 0;
  modifyDate: string = "";
  selectedRbd: string[] = [];
  pcc: string = "";
  withHoldingTaxValue: number = 0;
  withHoldingTaxPercentage: number = 0;
  seg1: number = 0;
  seg2: number = 0;
  seg3: number = 0;
  seg4: number = 0;
  seg5: number = 0;
  seg6: number = 0;
}
export class AirlineTypes {
  airlineTypeId: number = 0;
  typeName: string = "";
  creationUser: number = 0;
  creationDate: string = "";
  modifyUser: number = 0;
  modifyDate: string = "";
}

export class RevenueManagementBaseData {
  airports: RevenueManagementAirports[] = [];
  airlines: RevenueManagementAirlineCodes[] = [];
  countries: Countries[]=[];
}

export class RevenueManagementAirlineCodes {
  airlineCombineCode: string = "";
  airlineName: string = "";

}
export class RevenueManagementAirports {
  iATA_CODE: string = "";
  cityName: string = "";


}
export class Supplier_OficeID {
  officeId: string = "";
  uniquekey: string = "";
  supplierId: string = "";
}

export class RefundRevenueCalculateProperties {
  revenueId: number;
  type: string;
  status: boolean;
  isOficeId: boolean;
  appliesOn: string;
  expiryDate: string;
  applyChildAgency: boolean;
  applyChildBranches: boolean;
  applyHO: boolean;
  cabinClass: string;
  passengerType: string;
  rbd: string;
  calculatedOn: string;
  expression: string;
  valueAmount: number;
  valuePercent: number;
  supplierId: string;
}
export class VoidRevenueCalculateProperties {
  revenueId: number;
  type: string;
  status: boolean;
  isOficeId: boolean;
  appliesOn: string;
  expiryDate: string;
  applyChildAgency: boolean;
  applyChildBranches: boolean;
  applyHO: boolean;
  cabinClass: string;
  passengerType: string;
  rbd: string;
  calculatedOn: string;
  expression: string;
  valueAmount: number;
  valuePercent: number;
  supplierId: string;
}
export class InsuranceRevenueCalculateProperties {
  revenueId: number = 0;
  type: string = "";
  status: boolean = true;
  //isOficeId: boolean = true;
  appliesOn: string = "";
  expiryDate: string = "";
  applyChildAgency: boolean = true;
  applyChildBranches: boolean = true;
  applyHO: boolean = true;
  passengerType: string = "";
  calculatedOn: string = "";
  //public string supplierId { get; set; }
  expression: string = "";
  valueAmount: number = 0;
  valuePercent: number = 0;
  vat: number = 0;
  vatPercent: number = 0;
}
